export default "__VITE_ASSET__CcFAMWAL__"